import { Link } from "react-router-dom";

/**
 * Generic page hero / wrapper to keep static pages visually consistent.
 */
export default function PageHero({ eyebrow, title, lead, breadcrumbs }) {
    return (
        <section
            className="bg-[#FDF9EF] border-b border-black/5"
            data-testid="page-hero"
        >
            <div className="px-4 md:px-8 lg:px-12 py-14 md:py-20 max-w-5xl">
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <nav
                        className="font-poppins text-xs tracking-[0.2em] uppercase text-[#1B1B1B]/60 mb-6 flex items-center gap-2 flex-wrap"
                        aria-label="Breadcrumb"
                    >
                        {breadcrumbs.map((b, i) => (
                            <span key={i} className="flex items-center gap-2">
                                {b.to ? (
                                    <Link
                                        to={b.to}
                                        className="hover:text-[#E63B26]"
                                    >
                                        {b.label}
                                    </Link>
                                ) : (
                                    <span className="text-[#1B1B1B]">
                                        {b.label}
                                    </span>
                                )}
                                {i < breadcrumbs.length - 1 && (
                                    <span className="opacity-40">/</span>
                                )}
                            </span>
                        ))}
                    </nav>
                )}
                {eyebrow && (
                    <p className="font-poppins text-xs tracking-[0.3em] uppercase text-[#E63B26] mb-3">
                        {eyebrow}
                    </p>
                )}
                <h1 className="font-poppins font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-[#1B1B1B] leading-[1.04]">
                    {title}
                </h1>
                {lead && (
                    <p className="mt-5 font-sofia text-lg md:text-xl text-[#1B1B1B]/80 max-w-2xl leading-relaxed">
                        {lead}
                    </p>
                )}
            </div>
        </section>
    );
}
